import { render, staticRenderFns } from "./AddCouponRuleFee.vue?vue&type=template&id=6171d566&scoped=true"
import script from "./AddCouponRuleFee.vue?vue&type=script&lang=js"
export * from "./AddCouponRuleFee.vue?vue&type=script&lang=js"
import style0 from "./AddCouponRuleFee.vue?vue&type=style&index=0&id=6171d566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6171d566",
  null
  
)

export default component.exports